namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmKrokTrasy extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmKrokTrasyReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmKrokTrasyObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmKrokTrasyObj());
            this.detailObj.createBase({
                contentName: "detailAdmKrokTrasy",
                contentCaption: "jres:33000800",  //RC 33000800 : Krok trasy
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            tabs.push(this.detailObj.getParametryKrokuTab());
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            groups.push(this.detailObj.getParametryKrokuGroup());
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmKrokTrasy", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmKrokTrasyObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmKrokTrasyReadDto> {
        parametry_forms: GParametrForm[]

        create() {
            this.parametry_forms = [];
            this.createTabFormsAndGrids();
        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_tra}#${this.data.por_cislo}#`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmKrokTrasySaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.typ_krok != undefined)
                data.parametry_kroku_trasy = this.getDataParametryForm(data.typ_krok);
            if (this.data.por_cislo != null && this.data.por_cislo != undefined)
                data.por_cislo = this.data.por_cislo;
            (this.cnt.isl.AdmKrokTrasy.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        private getDataParametryForm(typ_krok: number): Gordic.Adm.Interface.GWfldcftDto[] {
            var krok = this.parametry_forms.find(item => item.id == typ_krok);
            var parametry: Gordic.Adm.Interface.GWfldcftDto[] = [];
            if (krok != null && krok != undefined) {
                var tab = $(".tab-group-_tab-parametry-kroku");
                var dataForm = {};
                var form = tab.findForms(krok.name);
                if (form.gform("isValid") == true) {
                    form.findFields().gfield("model", "collect", dataForm);
                    parametry = krok.collectData(dataForm);
                }
            }
            return parametry;
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKrokTrasy", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmKrokTrasy.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            this.setEditModeTab(editMode, $(".tab-group-_tab-parametry-kroku"));
            if (this.data.typ_krok == 10070) {
                var form = this.cnt.findForms("automaticke-vytvoreni-spisu");
                var rok_spz_aktual = form.findFields("rok_spz_aktual").gfield("getValue");
                var ixs_typ_aktual = form.findFields("ixs_typ_aktual").gfield("getValue");
                form.findFields("rok_spz").gfield(rok_spz_aktual == true ? "disable" : "enable")
                form.findFields("rok_spz").gfield("setValidators", rok_spz_aktual == true ? [] : [new Gordic.Validators.Required({ stopping: true })])
                form.findFields("ixs_typ").gfield(ixs_typ_aktual == true ? "disable" : "enable")
                form.findFields("ixs_typ").gfield("setValidators", ixs_typ_aktual == true ? [] : [new Gordic.Validators.Required({ stopping: true })])
            } else if (this.data.typ_krok == 10050) {
                var form = this.cnt.findForms("automaticke-zalozeni-cj");
                var rok_cj_aktual = form.findFields("rok_cj_aktual").gfield("getValue");
                form.findFields("rok_cj").gfield(rok_cj_aktual == true ? "disable" : "enable");
                form.findFields("rok_cj").gfield("setValidators", rok_cj_aktual == true ? [] : [new Gordic.Validators.Required({ stopping: true })]);
            }
        }

        createForm() {
            this.data.parametry_kroku_trasy
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("")
            this.MakeSelectField("ixs_tra", Gordic.Prefabs.Select.wflstra(), { model: "model.ixs_tra=value.ixs_tra" })
            this.MakeField("poradi")
            this.MakeSelectField("typ_krok", Gordic.Prefabs.Select.admWflctkr(), {
                model: "model.typ_krok=value.typ_krok",
                dropdown: true,
                serverFilters: {
                    typ_krok: this.parametry_forms.map((item) => item.id)
                },
                change: (ev, obj) => {
                    var tab = $(".tab-group-_tab-parametry-kroku")
                    tab.children().hide();
                    if (obj.value != null && obj.value != undefined) {
                        var objTmp = obj.value as any
                        if (!Array.isArray(obj)) {
                            var form = this.parametry_forms.find(item => item.id == objTmp.typ_krok);
                            var formEl = tab.findForms((form?.name != undefined && form?.name != null) ? form?.name : "")
                            formEl.show();
                            if (this.data.parametry_kroku_trasy) {
                                var inputData = form?.convertData(this.data.parametry_kroku_trasy)
                                formEl.findFields().gfield("model", "apply", inputData)
                            }
                            if (objTmp.typ_krok == 0) {
                                this.cnt.findFields("ixs_fun_pov").gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
                            } else {
                                this.cnt.findFields("ixs_fun_pov").gfield("setValidators", [])
                            }
                        }
                    } else {
                        this.cnt.findFields("ixs_fun_pov").gfield("setValidators", [])
                    }
                }
            })
            this.MakeField("nazev")
            this.MakeField("dnu_termin", {
                validators: [new Gordic.Validators.Range({ stopping: true, min: 0 })]
            })
            this.MakeBoolField("typ_dnu_termin")
            this.MakeSection("") //RC 33000801 : Pověřená osoba - nositel (realizátor) úkolu
            this.MakeSelectField("ixs_su_pov", Gordic.Prefabs.Select.ginspod(), { model: "model.ixs_su_pov=value.ixs_su" })
            this.MakeSelectField("ixs_fun_pov", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun_pov=value.ixs_fun",
                dropdown: false
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        getParametryKrokuTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-parametry-kroku",
                    title: "jres:33000802", //RC 33000802 : Parametry kroku
                    opened: true,
                    locked: true,
                    group: { id: "_tab-parametry-kroku" }
                },
                init: (tab) => { this.createTabContent(tab) }
            }
        }

        getParametryKrokuGroup(): IGTabGroupOptions {
            return { id: "_tab-parametry-kroku", caption: "jres:33000802" }
        }

        private createTabContent(tab) {
            this.parametry_forms.forEach((item) => {
                item.elObj.appendTo(tab);
            })
            this.setEditModeTab(this.options.newRecord == true ? true : this.editMode, tab);
        }

        private setEditModeTab(editMode: boolean, tab: JQuery<HTMLElement>) {
            this.parametry_forms.forEach((item) => {
                if (item.fields)
                    tab.findForms(item.name).findFields().gfield(editMode == true ? "enable" : "disable");
            })
        }

        private createTabFormsAndGrids() {
            this.parametry_forms.push(
                {
                    name: "distribucni_krok",
                    id: 0,
                    elObj: this.createFormFunkcniMisto("distribucni_krok"),
                    fields: ["funkcni_misto"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["funkcni_misto"] = this.getDataFromParams(params, "ixs_fun_cil")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var ixs_fun_cil = this.getTxtDataFromModel("funkcni_misto", data);
                        var ixs_fun_cil_txt = this.getTxtDataFromModel("funkcni_misto_txt", data);
                        var dbObj = this.createParamDbObj("ixs_fun_cil", ixs_fun_cil)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_fun_cil_txt", ixs_fun_cil_txt)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "uzivatelske_rozhodnuti",
                    id: 20,
                    elObj: this.createFormUzivatelskeRozhodnuti(),
                    fields: ["text_question", "ixs_tra_ano", "ixs_tra_ne"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["text_question"] = this.getDataFromParams(params, "text_question")
                        inputData["ixs_tra_ano"] = this.getDataFromParams(params, "ixs_tra_ano")
                        inputData["ixs_tra_ne"] = this.getDataFromParams(params, "ixs_tra_ne")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var text_question = this.getTxtDataFromModel("text_question", data);
                        var ixs_tra_ano = this.getTxtDataFromModel("ixs_tra_ano", data);
                        var ixs_tra_ne = this.getTxtDataFromModel("ixs_tra_ne", data);
                        var dbObj = this.createParamDbObj("text_question", text_question)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ano", ixs_tra_ano)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ne", ixs_tra_ne)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "vzit_na_vedomi",
                    id: 30,
                    elObj: this.createVzitNaVedomiForm(),
                    fields: ["text_instr"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["text_instr"] = this.getDataFromParams(params, "text_instr")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var text_instr = this.getTxtDataFromModel("text_instr", data);
                        var dbObj = this.createParamDbObj("text_instr", text_instr)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "schvalit_obsah_dokumentu",
                    id: 40,
                    elObj: this.createFormSchvalitObsahDokumentu(),
                    fields: ["text_instr", "ixs_tra_ano", "ixs_tra_ne"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["text_instr"] = this.getDataFromParams(params, "text_instr")
                        inputData["ixs_tra_ano"] = this.getDataFromParams(params, "ixs_tra_ano")
                        inputData["ixs_tra_ne"] = this.getDataFromParams(params, "ixs_tra_ne")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var text_instr = this.getTxtDataFromModel("text_instr", data);
                        var ixs_tra_ano = this.getTxtDataFromModel("ixs_tra_ano", data);
                        var ixs_tra_ne = this.getTxtDataFromModel("ixs_tra_ne", data);
                        var dbObj = this.createParamDbObj("text_instr", text_instr)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ano", ixs_tra_ano)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ne", ixs_tra_ne)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "pokyn",
                    id: 50,
                    elObj: this.createFormPokyn(),
                    fields: ["text_instr"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["text_instr"] = this.getDataFromParams(params, "text_instr")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var text_instr = this.getTxtDataFromModel("text_instr", data);
                        var dbObj = this.createParamDbObj("text_instr", text_instr)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "historie-dokumentu",
                    id: 10000,
                    elObj: this.createZapisHistorie(),
                    fields: ["text_hist"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["text_hist"] = this.getDataFromParams(params, "text_hist")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var text_hist = this.getTxtDataFromModel("text_hist", data);
                        var dbObj = this.createParamDbObj("text_hist", text_hist)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "paralel",
                    id: 10020,
                    elObj: this.createParallelTrasy(),
                    fields: ["ixs_tra_param"],
                    convertData: (params) => {
                        var inputData = {};
                        var ixs_tra_param = params.filter(item => item.param_tra == "ixs_tra")
                        if (ixs_tra_param.length > 0)
                            inputData["ixs_tra_param"] = ixs_tra_param.map(item => ({ ixs_tra: item.config_tra }))
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var ixs_tra = this.getTxtDataFromModel("ixs_tra_param", data);
                        var index = 1;
                        ixs_tra.forEach((item) => {
                            var dbObj = this.createParamDbObj("ixs_tra", item.ixs_tra, index);
                            if (dbObj != null)
                                resultData.push(dbObj)
                            index++;
                        })
                        return resultData;
                    }
                },
                {
                    name: "automaticke-predani",
                    id: 10040,
                    elObj: this.createFormAutomatickePredani(),
                    fields: ["ixs_fun_cil"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["ixs_fun_cil"] = this.getDataFromParams(params, "ixs_fun_cil")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var ixs_fun_cil = this.getTxtDataFromModel("ixs_fun_cil", data);
                        var ixs_fun_cil_txt = this.getTxtDataFromModel("ixs_fun_cil_txt", data);
                        var dbObj = this.createParamDbObj("ixs_fun_cil", ixs_fun_cil)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_fun_cil_txt", ixs_fun_cil_txt)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "automaticke-zalozeni-cj",
                    id: 10050,
                    elObj: this.createFormAutomatickeZalozeniCj(),
                    fields: ["sslden_cj", "rok_cj", "rok_cj_aktual"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["sslden_cj"] = this.getDataFromParams(params, "sslden_cj")
                        var rok_cj = this.getDataFromParams(params, "rok_cj")
                        if (rok_cj == null || rok_cj == undefined || rok_cj.trim() == '') {
                            inputData["rok_cj_aktual"] = true
                            inputData["rok_cj"] = null;
                        } else {
                            inputData["rok_cj_aktual"] = false
                            inputData["rok_cj"] = rok_cj;
                        }
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var sslden_cj = this.getTxtDataFromModel("sslden_cj", data);
                        var rok_cj_aktual = this.getTxtDataFromModel("rok_cj_aktual", data);
                        var dbObj = this.createParamDbObj("sslden_cj", sslden_cj)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        if (rok_cj_aktual == true) {
                            dbObj = {
                                param_tra: "rok_cj",
                                param_tra_txt: "rok_cj",
                                config_tra: "",
                                config_tra_txt: "",
                                aktivita: 100,
                                param_tra_index: 0
                            }
                            resultData.push(dbObj);
                        } else {
                            var rok_cj = this.getTxtDataFromModel("rok_cj", data);
                            dbObj = this.createParamDbObj("rok_cj", rok_cj)
                            if (dbObj != null)
                                resultData.push(dbObj)
                        }
                        return resultData;
                    }
                },
                {
                    name: "automaticke-vyrizeni-cj",
                    id: 10060,
                    elObj: this.createFormAutomatickeVyrizeniCj(),
                    fields: ["spis_znak", "spis_pl", "zp_vyriz"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["zp_vyriz"] = this.getDataFromParams(params, "zp_vyriz");
                        inputData["spis_pl"] = this.getDataFromParams(params, "spis_pl");
                        inputData["spis_znak"] = this.getDataFromParams(params, "spis_znak");
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var zp_vyriz = this.getTxtDataFromModel("zp_vyriz", data);
                        var zp_vyriz_txt = this.getTxtDataFromModel("zp_vyriz_txt", data);
                        var spis_pl = this.getTxtDataFromModel("spis_pl", data);
                        var spis_znak = this.getTxtDataFromModel("spis_znak", data);
                        var dbObj = this.createParamDbObj("zp_vyriz", zp_vyriz)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("zp_vyriz_txt", zp_vyriz_txt)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("spis_pl", spis_pl)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("spis_znak", spis_znak)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "automaticke-vytvoreni-spisu",
                    id: 10070,
                    elObj: this.createFormAutomaticvkeZalozeniSpisu(),
                    fields: ["sslden_spz", "rok_spz_aktual", "rok_spz", "ixs_typ_aktual", "ixs_typ"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["sslden_spz"] = this.getDataFromParams(params, "sslden_spz")
                        var rok_spz = this.getDataFromParams(params, "rok_spz")
                        if (rok_spz == null || rok_spz == undefined || rok_spz.trim() == '') {
                            inputData["rok_spz_aktual"] = true
                            inputData["rok_spz"] = null;
                        } else {
                            inputData["rok_spz_aktual"] = false
                            inputData["rok_spz"] = rok_spz;
                        }
                        var ixs_typ = this.getDataFromParams(params, "ixs_typ")
                        if (ixs_typ == null || ixs_typ == undefined || ixs_typ.trim() == '') {
                            inputData["ixs_typ_aktual"] = true
                            inputData["ixs_typ"] = null;
                        } else {
                            inputData["ixs_typ_aktual"] = false
                            inputData["ixs_typ"] = ixs_typ.split("#")[0];
                        }
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var sslden_spz = this.getTxtDataFromModel("sslden_spz", data);
                        var dbObj = this.createParamDbObj("sslden_spz", sslden_spz)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        var ixs_typ_aktual = this.getTxtDataFromModel("ixs_typ_aktual", data);
                        if (ixs_typ_aktual == true) {
                            dbObj = {
                                param_tra: "ixs_typ",
                                param_tra_txt: "ixs_typ",
                                config_tra: "",
                                config_tra_txt: "",
                                aktivita: 100,
                                param_tra_index: 0
                            }
                            resultData.push(dbObj);
                        } else {
                            var ixs_typ = this.getTxtDataFromModel("ixs_typ", data);
                            var ktg_typ = this.getTxtDataFromModel("ktg_typ", data);
                            dbObj = this.createParamDbObj("ixs_typ", `${ixs_typ}#${ktg_typ}#`)
                            if (dbObj != null)
                                resultData.push(dbObj)
                        }
                        var rok_spz_aktual = this.getTxtDataFromModel("rok_spz_aktual", data);
                        if (rok_spz_aktual == true) {
                            dbObj = {
                                param_tra: "rok_spz",
                                param_tra_txt: "rok_spz",
                                config_tra: "",
                                config_tra_txt: "",
                                aktivita: 100,
                                param_tra_index: 0
                            }
                            resultData.push(dbObj);
                        } else {
                            var rok_spz = this.getTxtDataFromModel("rok_spz", data);
                            dbObj = this.createParamDbObj("rok_spz", rok_spz)
                            if (dbObj != null)
                                resultData.push(dbObj)
                        }
                        return resultData;
                    }
                },
                {
                    name: "automaticke-vyrizeni-spisu",
                    id: 10080,
                    elObj: this.createFormAutomatickeVyrizeniSpisu(),
                    fields: ["zp_vyriz", "spis_pl", "spis_znak"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["zp_vyriz"] = this.getDataFromParams(params, "zp_vyriz");
                        inputData["spis_pl"] = this.getDataFromParams(params, "spis_pl");
                        inputData["spis_znak"] = this.getDataFromParams(params, "spis_znak");
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var zp_vyriz = this.getTxtDataFromModel("zp_vyriz", data);
                        var zp_vyriz_txt = this.getTxtDataFromModel("zp_vyriz_txt", data);
                        var spis_pl = this.getTxtDataFromModel("spis_pl", data);
                        var spis_znak = this.getTxtDataFromModel("spis_znak", data);
                        var dbObj = this.createParamDbObj("zp_vyriz", zp_vyriz)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("zp_vyriz_txt", zp_vyriz_txt)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("spis_pl", spis_pl)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("spis_znak", spis_znak)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "automaticke-vyrizeni-ad-acta",
                    id: 10090,
                    elObj: this.createFormAutomatickeVyrizeniAdActa(),
                    fields: ["spis_pl", "spis_znak"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["spis_pl"] = this.getDataFromParams(params, "spis_pl");
                        inputData["spis_znak"] = this.getDataFromParams(params, "spis_znak");
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var spis_pl = this.getTxtDataFromModel("spis_pl", data);
                        var spis_znak = this.getTxtDataFromModel("spis_znak", data);
                        var dbObj = this.createParamDbObj("spis_pl", spis_pl)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("spis_znak", spis_znak)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "automaticke-uzavreni-spisu",
                    id: 10100,
                    elObj: this.createFormAutomaticClose(),
                    fields: [],
                    convertData: (params) => {
                        var inputData = {};
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        return resultData;
                    }
                },
                {
                    name: "odeslani-mailu",
                    id: 10110,
                    elObj: this.createFormOdeslaniMailu(),
                    fields: ["adresaprijemce", "predmetzpravy", "textzpravy"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["adresaprijemce"] = this.getDataFromParams(params, "adresaprijemce");
                        inputData["predmetzpravy"] = this.getDataFromParams(params, "predmetzpravy");
                        inputData["textzpravy"] = this.getDataFromParams(params, "textzpravy");
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var adresaprijemce = this.getTxtDataFromModel("adresaprijemce", data);
                        var predmetzpravy = this.getTxtDataFromModel("predmetzpravy", data);
                        var textzpravy = this.getTxtDataFromModel("textzpravy", data);
                        var dbObj = this.createParamDbObj("adresaprijemce", adresaprijemce)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("predmetzpravy", predmetzpravy)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("textzpravy", textzpravy)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "pozastaveni-trasy",
                    id: 10120,
                    elObj: this.createFormPozastaveniTrasy(),
                    fields: ["waitminut", "waithodin", "waitdni"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["waitminut"] = this.getDataFromParams(params, "waitminut");
                        inputData["waithodin"] = this.getDataFromParams(params, "waithodin");
                        inputData["waitdni"] = this.getDataFromParams(params, "waitdni");
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var waitminut = this.getTxtDataFromModel("waitminut", data);
                        var waithodin = this.getTxtDataFromModel("waithodin", data);
                        var waitdni = this.getTxtDataFromModel("waitdni", data);
                        var dbObj = this.createParamDbObj("waitminut", waitminut)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("waithodin", waithodin)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("waitdni", waitdni)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "vykonani-prikazu",
                    id: 10130,
                    elObj: this.createFormVykonaniPrikazu(),
                    fields: ["expressions"],
                    convertData: (params) => {
                        var inputData = {};
                        var expr = params.filter(item => item.param_tra == "expr");
                        var prop_name = params.filter(item => item.param_tra == "prop_name");
                        inputData["expressions"] = [];
                        expr.forEach((item) => {
                            var propname = prop_name.find(propitem => propitem.param_tra_index == item.param_tra_index);
                            inputData["expressions"].push({ prop_name: propname?.config_tra, expr: item.config_tra })
                        })
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var expr = this.getTxtDataFromModel("expressions", data);
                        var index = 1;
                        expr.forEach((item) => {
                            resultData.push({
                                param_tra: "expr",
                                param_tra_txt: "expr",
                                config_tra: item["expr"],
                                config_tra_txt: item["expr"],
                                aktivita: 100,
                                param_tra_index: index
                            });
                            resultData.push({
                                param_tra: "prop_name",
                                param_tra_txt: "prop_name",
                                config_tra: item["prop_name"],
                                config_tra_txt: item["prop_name"],
                                aktivita: 100,
                                param_tra_index: index
                            })
                            index++;
                        })
                        return resultData;
                    }
                },
                {
                    name: "vetveni-trasy-vyraz",
                    id: 10140,
                    elObj: this.createFormVetveniTrasyVyraz(),
                    fields: ["expr", "ixs_tra_ano", "ixs_tra_ne"],
                    convertData: (params) => {
                        var inputData = {};
                        inputData["expr"] = this.getDataFromParams(params, "expr")
                        inputData["ixs_tra_ano"] = this.getDataFromParams(params, "ixs_tra_ano")
                        inputData["ixs_tra_ne"] = this.getDataFromParams(params, "ixs_tra_ne")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var expr = this.getTxtDataFromModel("expr", data);
                        var ixs_tra_ano = this.getTxtDataFromModel("ixs_tra_ano", data);
                        var ixs_tra_ne = this.getTxtDataFromModel("ixs_tra_ne", data);
                        var dbObj = this.createParamDbObj("expr", expr)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ano", ixs_tra_ano)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        dbObj = this.createParamDbObj("ixs_tra_ne", ixs_tra_ne)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                },
                {
                    name: "podminene-cekani",
                    id: 10150,
                    elObj: this.createFormPodmineneCekani(),
                    fields: ["expressions", "wait_expr"],
                    convertData: (params) => {
                        var inputData = {};
                        var expr = params.filter(item => item.param_tra == "expr");
                        var prop_name = params.filter(item => item.param_tra == "prop_name");
                        inputData["expressions"] = [];
                        expr.forEach((item) => {
                            var propname = prop_name.find(propitem => propitem.param_tra_index == item.param_tra_index);
                            inputData["expressions"].push({ prop_name: propname?.config_tra, expr: item.config_tra })
                        })
                        inputData["wait_expr"] = this.getDataFromParams(params, "wait_expr")
                        return inputData;
                    },
                    collectData: (data) => {
                        var resultData: Gordic.Adm.Interface.GWfldcftDto[] = [];
                        var expr = this.getTxtDataFromModel("expressions", data);
                        var index = 1;
                        expr.forEach((item) => {
                            resultData.push({
                                param_tra: "expr",
                                param_tra_txt: "expr",
                                config_tra: item["expr"],
                                config_tra_txt: item["expr"],
                                aktivita: 100,
                                param_tra_index: index
                            });
                            resultData.push({
                                param_tra: "prop_name",
                                param_tra_txt: "prop_name",
                                config_tra: item["prop_name"],
                                config_tra_txt: item["prop_name"],
                                aktivita: 100,
                                param_tra_index: index
                            })
                            index++;
                        })
                        var wait_expr = this.getTxtDataFromModel("wait_expr", data);
                        var dbObj = this.createParamDbObj("wait_expr", wait_expr)
                        if (dbObj != null)
                            resultData.push(dbObj)
                        return resultData;
                    }
                }
            )
        }

        // REGION jednotlive formulare

        private createFormFunkcniMisto(name: string): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: name })
                .addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "funkcni_misto",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.funkcni_misto=value.ixs_fun;model.funkcni_misto_txt<=value.nazev_rf",
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormUzivatelskeRozhodnuti(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "uzivatelske_rozhodnuti" })
                .addRow("jres:33000803").addField("gstringbox", { //RC 33000803 : Text dotazu
                    name: "text_question",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000804").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000804 : Trasa pro ANO
                    name: "ixs_tra_ano",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ano=value.ixs_tra"
                })
                .addRow("jres:33000805").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000805 : Trasa pro NE
                    name: "ixs_tra_ne",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ne=value.ixs_tra"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createVzitNaVedomiForm(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "vzit_na_vedomi" })
                .addRow("jres:33000806").addField("gstringbox", { //RC 33000806 : Upřesnění
                    name: "text_instr",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormSchvalitObsahDokumentu(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "schvalit_obsah_dokumentu" })
                .addRow("jres:33000806").addField("gstringbox", {
                    name: "text_instr",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000804").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000804 : Trasa pro ANO
                    name: "ixs_tra_ano",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ano=value.ixs_tra"
                })
                .addRow("jres:33000805").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000805 : Trasa pro NE
                    name: "ixs_tra_ne",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ne=value.ixs_tra"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormPokyn(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "pokyn" })
                .addRow("jres:33000807").addField("gstringbox", { //RC 33000807 : Text pokynu
                    name: "text_instr",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createZapisHistorie(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "historie-dokumentu" })
                .addRow("jres:33000808").addField("gstringbox", { //RC 33000808 : Text zápisu
                    name: "text_hist",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createParallelTrasy(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "paralel" })
                .addRow("jres:33000809").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000809 : Vybrané trasy
                    name: "ixs_tra_param",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    dropdown: true,
                    multi: true
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomatickePredani(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-predani" })
                .addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs_fun_cil",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_fun_cil=value.ixs_fun;model.ixs_fun_cil_txt<=value.nazev_rf"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomatickeZalozeniCj(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-zalozeni-cj", customClass: "automaticke-zalozeni-cj" })
                .addRow("jres:33000812").addField("gselectbox", Gordic.Prefabs.Select.admsslsden(), { //RC 33000812 : Deník SSL
                    name: "sslden_cj",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.sslden_cj=value.sslden"
                })
                .addRow("jres:33000811").addField("gcheck", { //RC 33000811 : Rok dosadit podle aktuálního data
                    labelFromRow: "always",
                    name: "rok_cj_aktual",
                    change: (ev, obj) => {
                        var fieldRok = this.cnt.findForms("automaticke-zalozeni-cj").findFields("rok_cj");
                        if (obj.value == true && this.editMode == true) {
                            fieldRok.gfield("setValue", null);
                        }
                        fieldRok.gfield(this.editMode == false ? "disable" : (obj.value == true ? "disable" : "enable"));
                        fieldRok.gfield("setValidators", this.editMode == false ? [] : (obj.value == true ? [] : [new Gordic.Validators.Required({ stopping: true })]));
                    }
                })
                .addRow("jres:33000810").addField("gselectbox", Gordic.Prefabs.Select.admSsldden(), { //RC 33000810 : Rok
                    name: "rok_cj",
                    model: "model.rok_cj=value.rok;model.sslden_cj=>value.sslden",
                    serverFilters: {
                        sslden: new Gordic.Forms.Dependency("sslden_cj", "sslden", true, false/*, $(".automaticke-zalozeni-cj")*/)
                    }
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomatickeVyrizeniCj(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-vyrizeni-cj" })
                .addRow("jres:33000813").addField("gselectbox", Gordic.Prefabs.Select.sslszvs(), { //RC 33000813 : Způsob vyřízení
                    name: "zp_vyriz",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.zp_vyriz=value.zp_vyriz;model.zp_vyriz_txt<=value.zp_vyriz_txt"
                })
                .addRow("jres:33000814").addField("gselectbox", Gordic.Prefabs.Select.admsslsspl(), { //RC 33000814 : Spisový plán
                    name: "spis_pl",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_pl=value.spis_pl",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
                .addRow("jres:33000815").addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), { //RC 33000815 : Spisový znak
                    name: "spis_znak",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_znak=value.spis_znak",
                    serverFilters: {
                        spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false),
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomaticvkeZalozeniSpisu(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-vytvoreni-spisu" })
                .addRow("jres:33000812").addField("gselectbox", Gordic.Prefabs.Select.admsslsden(), { //RC 33000812 : Deník SSL
                    name: "sslden_spz",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.sslden_spz=value.sslden"
                })
                .addRow("jres:33000811").addField("gcheck", { //RC 33000811 : Rok dosadit podle aktuálního data
                    labelFromRow: "always",
                    name: "rok_spz_aktual",
                    change: (ev, obj) => {
                        var fieldRok = this.cnt.findForms("automaticke-vytvoreni-spisu").findFields("rok_spz");
                        if (obj.value == true && this.editMode == true) {
                            fieldRok.gfield("setValue", null);
                        }
                        fieldRok.gfield(this.editMode == false ? "disable" : (obj.value == true ? "disable" : "enable"));
                        fieldRok.gfield("setValidators", this.editMode == false ? [] : (obj.value == true ? [] : [new Gordic.Validators.Required({ stopping: true })]));
                    }
                })
                .addRow("jres:33000810").addField("gselectbox", Gordic.Prefabs.Select.admSsldden(), { //RC 33000810 : Rok
                    name: "rok_spz",
                    model: "model.rok_spz=value.rok;model.sslden_spz=>value.sslden",
                    serverFilters: {
                        sslden: new Gordic.Forms.Dependency("sslden_spz", "sslden", true, false)
                    }
                })
                .addRow("jres:33000816").addField("gcheck", { //RC 33000816 : Typ dokumentu převzít z iniciačního dokumentu
                    labelFromRow: "always",
                    name: "ixs_typ_aktual",
                    change: (ev, obj) => {
                        var fieldRok = this.cnt.findForms("automaticke-vytvoreni-spisu").findFields("ixs_typ");
                        if (obj.value == true && this.editMode == true) {
                            fieldRok.gfield("setValue", null);
                        }
                        fieldRok.gfield(this.editMode == false ? "disable" : (obj.value == true ? "disable" : "enable"));
                        fieldRok.gfield("setValidators", this.editMode == false ? [] : (obj.value == true ? [] : [new Gordic.Validators.Required({ stopping: true })]));
                    }
                })
                .addRow("jres:33000817").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), { //RC 33000817 : Typ dokumentu
                    name: "ixs_typ",
                    model: "model.ixs_typ=value.ixs_typ;model.ktg_typ<=value.ktg_typ",
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomatickeVyrizeniSpisu(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-vyrizeni-spisu" })
                .addRow("jres:33000813").addField("gselectbox", Gordic.Prefabs.Select.sslszvs(), { //RC 33000813 : Způsob vyřízení
                    name: "zp_vyriz",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.zp_vyriz=value.zp_vyriz;model.zp_vyriz_txt<=value.zp_vyriz_txt"
                })
                .addRow("jres:33000814").addField("gselectbox", Gordic.Prefabs.Select.admsslsspl(), { //RC 33000814 : Spisový plán
                    name: "spis_pl",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_pl=value.spis_pl",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
                .addRow("jres:33000815").addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), { //RC 33000815 : Spisový znak
                    name: "spis_znak",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_pl=>value.spis_pl;model.spis_znak=value.spis_znak",
                    serverFilters: {
                        spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, true),
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomatickeVyrizeniAdActa(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-vyrizeni-ad-acta" })
                .addRow("jres:33000814").addField("gselectbox", Gordic.Prefabs.Select.admsslsspl(), { //RC 33000814 : Spisový plán
                    name: "spis_pl",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_pl=value.spis_pl",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
                .addRow("jres:33000815").addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), { //RC 33000815 : Spisový znak
                    name: "spis_znak",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.spis_pl=>value.spis_pl;model.spis_znak=value.spis_znak",
                    serverFilters: {
                        spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false),
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormAutomaticClose(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "automaticke-uzavreni-spisu" })
            return $("<div>").gform("createFrom", form)
        }

        private createFormOdeslaniMailu(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "odeslani-mailu" })
                .addRow("jres:33000818").addField("gstringbox", { //RC 33000818 : Adresa příjemce
                    name: "adresaprijemce",
                    validators: [
                        new Gordic.Validators.Required({ stopping: true }),
                        new Gordic.Validators.RegExp({
                            stopping: true,
                            pattern: new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)
                        })],
                    flag: "required",
                })
                .addRow("jres:33000819").addField("gstringbox", { //RC 33000819 : Předmět zprávy
                    name: "predmetzpravy",
                    validators: [
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
                .addRow("jres:33000820").addField("gstringbox", Gordic.Prefabs.Field.charCounter(254), { //RC 33000820 : Text zprávy
                    name: "textzpravy",
                    rows: 5,
                    validators: [
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                });
            return $("<div>").gform("createFrom", form)
        }

        private createFormPozastaveniTrasy(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "pozastaveni-trasy" })
                .addRow("jres:33000826").addField("gnumberbox", { //RC 33000826 : Čekat minut
                    name: "waitminut",
                    emptyValue: 0,
                    validators: [
                        new Gordic.Validators.Range({ min: 0 }),
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
                .addRow("jres:33000827").addField("gnumberbox", { //RC 33000827 : Čekat hodin
                    name: "waithodin",
                    emptyValue: 0,
                    validators: [
                        new Gordic.Validators.Range({ min: 0 }),
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
                .addRow("jres:33000828").addField("gnumberbox", { //RC 33000828 : Čekat dní
                    name: "waitdni",
                    emptyValue: 0,
                    validators: [
                        new Gordic.Validators.Range({ min: 0 }),
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
            return $("<div>").gform("createFrom", form)
        }

        private createFormVykonaniPrikazu(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "vykonani-prikazu" })
                .addRow("jres:33000821").addField("gformbox", { //RC 33000821 : Příkazy
                    name: "expressions",
                    form: this.createFormExpression(),
                    multi: true,
                    itemTemplate: "jres:33000829 <b>{prop_name}</b> | jres:33000830 <b>{expr}</b>", //RC 33000830 : Výraz:
                    mode: "inlinesubmit",
                    itemEditable: (value) => {
                        return this.editMode
                    },
                    sortable: true,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
            return $("<div>").gform("createFrom", form)
        }

        private createFormVetveniTrasyVyraz(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "vetveni-trasy-vyraz" })
                .addRow("jres:33000824").addField("gstringbox", { //RC 33000824 : Výraz
                    name: "expr",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000804").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000804 : Trasa pro ANO
                    name: "ixs_tra_ano",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ano=value.ixs_tra"
                })
                .addRow("jres:33000805").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000805 : Trasa pro NE
                    name: "ixs_tra_ne",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.ixs_tra_ne=value.ixs_tra"
                })
            return $("<div>").gform("createFrom", form);
        }

        private createFormPodmineneCekani(): JQuery<HTMLElement> {
            var form = new Gordic.Forms.Form({ name: "podminene-cekani" })
                .addRow("jres:33000821").addField("gformbox", { //RC 33000821 : Příkazy
                    name: "expressions",
                    form: this.createFormExpression(),
                    multi: true,
                    itemTemplate: "jres:33000829 <b>{prop_name}</b> | jres:33000830 <b>{expr}</b>",
                    mode: "inlinesubmit",
                    itemEditable: (value) => {
                        return this.editMode
                    },
                    sortable: true,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000825").addField("gstringbox", { //RC 33000825 : Výraz podmínky pro pokračování
                    name: "wait_expr",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            return $("<div>").gform("createFrom", form)
        }

        private createFormExpression(): Gordic.Forms.Form {
            return new Gordic.Forms.Form({ name: "form-expression" })
                .addRow("jres:33000822").addField("gstringbox", { //RC 33000822 : Proměnná
                    name: "prop_name",
                    validators: [
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
                .addRow("jres:33000823").addField("gstringbox", { //RC 33000823 : Výraz
                    name: "expr",
                    validators: [
                        new Gordic.Validators.Required({ stopping: true }),
                    ],
                    flag: "required",
                })
        }

        private getDataFromParams(params: Gordic.Adm.Interface.GWfldcftDto[], name: string) {
            var param = params.find(item => item.param_tra == name)
            if (param)
                return param.config_tra
            else
                return null;
        }

        private getTxtDataFromModel(name: string, data: any): any {
            if (data[name])
                return data[name]
            return '';
        }

        private createParamDbObj(name: string, data: any, index?: number): Gordic.Adm.Interface.GWfldcftDto | null {
            if (typeof data === 'number' || data == 0) {
                return {
                    param_tra: name,
                    param_tra_txt: name,
                    config_tra: (data == 0) ? "0" : data.toString(),
                    config_tra_txt: (data == 0) ? "0" : data.toString(),
                    aktivita: 100,
                    param_tra_index: index ? index : 0
                }
            }
            else if (data.trim() != '' && data != undefined && data != null) {
                return {
                    param_tra: name,
                    param_tra_txt: name,
                    config_tra: data,
                    config_tra_txt: data,
                    aktivita: 100,
                    param_tra_index: index ? index : 0
                }
            }
            return null;
        }

        // ENDREGION
    }

    interface GParametrForm {
        name: string;
        elObj: JQuery<HTMLElement>;
        id: number;
        fields?: string[];
        convertData: (parametry: Gordic.Adm.Interface.GWfldcftDto[]) => any;
        collectData: (data: any) => Gordic.Adm.Interface.GWfldcftDto[];
    }
}